import { ApiMethodType } from '@celito.clients/enums';
import { performRequest } from '@celito.clients/network';
import { AxiosRequestConfig } from 'axios';
import Endpoints from 'libs/core/src/config/endpoint';

import { ControlledDocumentRecordUserActionsResponse } from './apiService.model';

export const getRecordUserActions = async (
  objectName: string,
  recordName: string,
  version: string
) => {
  const response =
    await performRequest<ControlledDocumentRecordUserActionsResponse>(
      `${Endpoints.OBJECT_DATA_URL}/${objectName}/${recordName}`,
      ApiMethodType.GET,
      null,
      {
        version,
        view_type: 'list',
      }
    );
  return response.data;
};

export type GenerateFileParams = {
  objectName: string;
  templateName: string;
  format: string;
  recordName: string;
  config?: AxiosRequestConfig;
  version?: string;
};

export const generateFile = async ({
  objectName,
  templateName,
  format,
  recordName,
  config,
  version,
}: GenerateFileParams) => {
  const versionParam = version ? `&record_version=${version}` : '';
  const response = await performRequest<{ data: Buffer }>(
    `${Endpoints.OBJECT_URL}/${objectName}/templates/${templateName}/generate?format=${format}&record_name=${recordName}${versionParam}`,
    ApiMethodType.POST,
    {},
    {},
    config
  );
  return response.data;
};
